export default __webpack_public_path__ + "static/media/superbonus-phoneMockup.89d01901.png";